import React from "react";
import { connect } from "react-redux";

import { isShopReady, getNewShopItems } from "state/school_money/selectors";

import Preloader from "components/app/home/Preloader";
import ShopItem from "components/app/home/sections/school_money/ShopItem";

// maximum number of shop items to show
const MAX_SHOP_ITEMS_COUNT = 3;

class NewShopItems extends React.Component {
  
  render() {
    
    const { shopItems, isLoading } = this.props;
    
    if (shopItems.size === 0) {
      return null;
    }
    
    return (
      <div className="home-section school_money-home-shop-items">
        <div className="home-section-heading home-section-heading--school_money school_money-home-shop-items__heading">New Shop Items</div>
        <Preloader isLoading={isLoading}>
          <div className="school_money-home-shop-items__body">
            { shopItems.map(shopItem => (
              <ShopItem key={shopItem.id} shopItem={shopItem} />
            )) }
          </div>
        </Preloader>
      </div>
    );
    
  }
  
}

export default connect(
  state => ({
    isLoading: !isShopReady(state),
    shopItems: getNewShopItems(state, MAX_SHOP_ITEMS_COUNT)
  })
)(NewShopItems);



// WEBPACK FOOTER //
// ./src/components/app/home/sections/school_money/NewShopItems.js